<template>
  <div class='SearchInput01'>
    <div class="icon">
      <close-icon color="#000000" @click="$emit('CloseSearch')"/>
    </div>
    <div class="cont-input">
      <input @input="run" type="text">
    </div>
    <div class="icon">
      <search-icon01/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CloseIcon from '../Icons/CloseIcon.vue'
import SearchIcon01 from '@/components/Theme01/Icons/SearchIcon01'
export default {
  name: 'SearchInput01',
  components: { SearchIcon01, CloseIcon },
  data () {
    return {
      timeout: null
    }
  },
  methods: {
    ...mapActions(['SearchProd01']),
    run (e) {
      if(this.timeout !== null) {
        clearTimeout(this.timeout)
      }
      this.$emit('load', true)
      this.timeout = setTimeout(() => {
        this.SearchProd01(e.target.value)
          .then(() => this.$emit('load', false))
      }, 800)
    }
  }
}
</script>

<style scoped>
.SearchInput01 {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  width: 20%;
}

.cont-input {
  width: 80%;
}

input {
  width: 96%;
  padding: 2%;
  font-size: 18px;
  border: 0;
  border-bottom: thin solid #CCCCCC;
}

input:focus {
  outline: none;
}
</style>
